<template>
  <div class="appointmentList-view">
    <p>{{ $t('finance', 'userInfo') }}</p>
    <commonTable :tableData="tableData" :loading="loading" :paginationVisible="false">
      <template v-slot:table>
        <el-table-column align="center" type="index" width="50" :label="$t('finance', 'sequenceNumber')"/>
        <el-table-column prop="avatarUrl" align="center" :label="$t('finance', 'avatar')">
          <template slot-scope="scope"
            ><img :src="scope.row.avatarUrl" class="w50 h50" />
          </template>
        </el-table-column>
        <el-table-column prop="nickeName" align="center" :label="$t('finance', 'name')" />
        <el-table-column prop="phone" align="center" :label="$t('finance', 'contactInfo')" />
        <el-table-column prop="successNum" align="center" :label="$t('finance', 'totalSuccessfulOrders')"/>
        <el-table-column prop="orderAmount" align="center" :label="$t('finance', 'totalOrderAmount')" />
        <el-table-column prop="sumBalance" align="center" :label="$t('finance', 'totalCommission')"/>
        <el-table-column prop="balance" align="center" :label="$t('finance', 'withdrawableCommission')" />
        <el-table-column prop="withdrawBalance" align="center" :label="$t('finance', 'withdrawingCommission')"/>
        <el-table-column prop="withdrawingBalance" align="center" :label="$t('finance', 'withdrawnCommission')"/>
      </template>
    </commonTable>
    <p class="">{{ $t('finance', 'commissionDetailNumber') }}</p>
    <commonTable :tableData="tableDataList"
                 @handleSizeChange="handleSizeChange"
                 @handleCurrentChange="handleCurrentChange"
                 :currentPage="currentPage"
                 :loading="loading"
                 :total="total">
      <template v-slot:table>
        <el-table-column prop="ordersNo" align="center" :label="$t('finance', 'orderNumber')" />
        <el-table-column prop="orderAmount" align="center" :label="$t('finance', 'orderRealPaymentAmount')" />
        <el-table-column prop="commissionRate" align="center" :label="$t('finance', 'commissionRate')" />
        <el-table-column prop="commissionAmount" align="center" :label="$t('finance', 'availableCommission')" />
        <el-table-column prop="completeTime" align="center" :label="$t('finance', 'orderCompletionTime')" />
      </template>
    </commonTable>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import {
  queryCommissionRecordDetail
} from "@/api/financing";
import { getDataTimeSec } from "@/utils";
import i18nMixin from "@/mixins/i18nMixin";

export default {
  name: "appointmentList",
  mixins: [i18nMixin],
  components: {
    commonTable,
  },
  data() {
    return {
      value: "",
      tableData: [],
      tableDataList:[],
      optionList:'', //全部分类
      loading:'',
      total: 0, //总条数
      currentPage: 1, //当前页数
      queryDate: "",
      pageNum: 1,
      pageSize: 10,
      detallId:'' , //详情id
    };
  },
  computed: {
    setDataTimeSec() {
      return (data) => getDataTimeSec(data);
    },
  },
  created(){
    this.detallId = this.$route.query.id;
    if (this.detallId) {
      this.getTableData();
    }
  },
  mounted(){

  },
  methods:{
    //请求表格数据
    getTableData() {
      this.loading = true;
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        distributorAppId: this.detallId,
      };
      queryCommissionRecordDetail(data)
      .then((res) => {
        let arr = []
        this.loading = false;
        this.tableData = [res.data] || [];
        console.log(this.tableData)
        this.total = res.data.total;
        this.tableDataList = res.data.responseList || [];
        if(this.tableDataList){
          this.tableDataList.forEach(item =>{
            item.commissionRate = item.commissionRate+"%";
          });
        }
      })
      .catch((err) => {
        this.loading = false;
        this.tableData = [];
      });
    },
    //当前页变更
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getTableData();
    },
    //当前页查询数据条数变更
    handleSizeChange(num) {
      this.pageSize = num;
      this.getTableData();
    },
  }
};
</script>

<style lang="scss" scoped>
.appointmentList-view {
  background: #ffffff;
  padding: 24px;
}
</style>